<div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">
  <div>

  </div>

  <div style="display: flex; flex-direction: row; margin: 16px 0 20px 0; align-items:center;">
    <button mat-raised-button
            (click)="createGenericControl()"
            style="border-radius: 6px;margin-right: 10px; "
            class="button">
      Create
    </button>
    <button mat-raised-button
            (click)="inputFile.click()"
            style="border-radius: 6px;margin-right: 10px; "
            class="button"
            matTooltip="{{this.constants.ATTACHMENT_FILE_DESCRIPTION}}">
      Import
    </button>
    <input #inputFile
           type="file"
           accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"
           (change)="import($event)"
           [style.display]="'none'">

  </div>
</div>

<div class="row" *ngIf='genericControls != null'>
  <div class="col-md-12">
    <p-table [value]="genericControls">

      <ng-template pTemplate="header">
        <tr>
          <th>Name</th>
          <th>Controls</th>
          <th>Topics</th>
          <th style="width: 14em;"></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
        <tr>
          <td>
            @if (item.editMode) {
              <mat-form-field>
                <input matInput [(ngModel)]="item.name" />
              </mat-form-field>
            } @else {
              {{ item.name }}
            }
          </td>
          <td>
            @for (controlItem of item.controlItems; track controlItem.controlItemId; let i = $index) {
              <div>
                {{ controlItem.complianceAreaName }} {{ controlItem.complianceAreaControlId }}
                @if (item.editMode) {
                  <span class="pi pi-trash cursor-pointer" (click)="item.controlItems.splice(i, 1)"></span>
                }
              </div>
            }
            @if (item.editMode) {
              <div class="pi pi-plus cursor-pointer" (click)="addControlItem(item)"></div>
            }
          </td>
          <td>
            @for (topic of item.topics; track topic.itemId; let i = $index) {
              <div>
                {{ topic.name }}
                @if (item.editMode) {
                  <span class="pi pi-trash cursor-pointer" (click)="item.topics.splice(i, 1)"></span>
                }
              </div>
            }
            @if (item.editMode) {
              <div class="pi pi-plus cursor-pointer" (click)="addTopic(item)"></div>
            }
          </td>
          <td>
            @if (!item.editMode) {
              <button type="button"
                      pButton
                      class="risksponge-button"
                      (click)="item.editMode = true"
                      icon="pi pi-pencil">
              </button>
            }
            @if (item.editMode) {
              <button type="button"
                      pButton
                      class="risksponge-button"
                      (click)="save(item)"
                      icon="pi pi-save">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      (click)="item.editMode = false"
                      icon="pi pi-times">
              </button>
            }
            <button type="button"
                    pButton
                    class="risksponge-button"
                    (click)="delete(item.id)"
                    icon="pi pi-trash">
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
